import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import './assets/css/base.css'
import './assets/css/animation.css'
import './assets/css/color.css'
import './assets/css/markdown-highlight.css'
import './assets/css/tocbot.css'
import './assets/css/index.css'
import './assets/css/aliIcon.css'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import Icon from './components/BlogFont.vue'


createApp(App).use(router).use(mavonEditor).use(ElementPlus).component('Icon',Icon).mount('#app')
